import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex overflow-auto h-55px mt-5 mb-10" }
const _hoisted_2 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Reminders ")
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Account Info ")
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Prime Monitoring ")
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Package Points ")
const _hoisted_11 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" PGI ")
const _hoisted_13 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" PGI Packages ")
const _hoisted_15 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Non-GA Tree ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      _createVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/dashboardecp/reminderspage",
          class: "nav-link text-active-primary me-6",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/dashboardecp/accountinfo",
          class: "nav-link text-active-primary me-6",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/dashboardecp/primemonitoring",
          class: "nav-link text-active-primary me-6",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createVNode("li", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: "/dashboardecp/packagepointslistecp",
          class: "nav-link text-active-primary me-6",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      (_ctx.isPGIQualified)
        ? (_openBlock(), _createBlock("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/dashboardecp/pgiecp",
              class: "nav-link text-active-primary me-6",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPGITop20Qualified)
        ? (_openBlock(), _createBlock("li", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: "/dashboardecp/pgiecptop20",
              class: "nav-link text-active-primary me-6",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentRank == 'GA' || _ctx.currentRank == 'GM' || _ctx.currentRank == 'RB' || _ctx.currentRank == 'DM')
        ? (_openBlock(), _createBlock("li", _hoisted_15, [
            _createVNode(_component_router_link, {
              to: "/dashboardecp/nonga",
              class: "nav-link text-active-primary me-6",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}